var exports = {
  "Qs": "x61f99309--1985e4--content",
  "Kk": "x61f99309--1985e4--icon",
  "qr": "x61f99309--1985e4--footer",
};

module.exports = exports;
